module.exports = __webpack_public_path__ + "static/media/portrait_pixel.5c465e06.jpg";